(function(){
  function calc(){
    var p=+document.getElementById('cP').value||0,
        n=+document.getElementById('cN').value||0,
        u=+document.getElementById('cU').value||0,
        s=+document.getElementById('cS').value||0;
    var r=(p*(1+u/100)-p)*n-(s*12);
    document.getElementById('cR').textContent='€'+Math.round(r).toLocaleString('nl-NL');
  }
  document.querySelectorAll('#cP,#cN,#cU,#cS').forEach(function(el){
    el.addEventListener('input',calc);
  });
  calc();
})();
